<script>
  export default {
    name: "CheckRow",
    props: {
      label: {
        type: String,
        required: true,
      },
      checkValue: {
        type: Boolean,
        default: false,
      },
      color: {
        type: String,
        default: null,
      },
      onChange: {
        type: Function,
        default: null,
      },
    },
    data() {
      return {
        isChecked: this.checkValue,
      };
    },
    watch: {
      checkValue(newVal) {
        this.isChecked = newVal;
      },
    },
    methods: {
      handleCheckedChange() {
        this.isChecked = !this.isChecked;

        this.$emit("change", this.isChecked);

        if (typeof this.onChange === "function") {
          this.onChange(this.isChecked);
        }
      },
    },
  };
</script>

<template>
  <label class="customCheckbox">
    <div class="customCheckbox__wrapper">
      <input class="customCheckbox__input" type="checkbox" :checked="isChecked" @change="handleCheckedChange" />
      <span
        class="customCheckbox__checkmark"
        :style="{
          backgroundColor: isChecked && color ? color : '',
          border: isChecked ? 'none' : '',
        }"
      />
    </div>
    <span class="customCheckbox__label">{{ label }}</span>
  </label>
</template>

<style lang="scss" scoped>
  .customCheckbox {
    @include Flex(row, unset, center);
    width: fit-content;
    gap: 6px;
    cursor: pointer;

    &__wrapper {
      @include Flex(row, unset, center);
      position: relative;
    }

    &__input {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      opacity: 0;
      cursor: pointer;
    }

    &__checkmark {
      position: relative;
      width: 14px;
      height: 14px;
      border-radius: 4px;
      border: 1px solid #bfbdbd;
      background-color: #fff;
      transition: background-color 0.3s ease;

      &::after {
        content: "";
        position: absolute;
        display: none;
        top: 50%;
        left: 50%;
        width: 4px;
        height: 7px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: translate(-50%, -60%) rotate(45deg);
      }
    }

    &__input:checked + &__checkmark {
      background-color: $primary-color;
    }

    &__input:checked + &__checkmark::after {
      display: block;
    }

    &__label {
      font-size: 16px;
      user-select: none;
    }
  }
</style>
